module.exports = __webpack_public_path__ + "img/blue-angle.f3cbd0bf.svg";